export default function (date, baseDate) {
  return date.toRelative({
    base: baseDate,
    units: ['hours', 'minutes', 'seconds'],
    locale: navigator.language,
  });
}
